module.exports = __webpack_public_path__ + "static/media/power-button-svgrepo-com.506310e1.svg";